import { COLORS } from 'helpers/globals'

const column = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%'
}

const button = {
  color: 'white',
  background: COLORS.primary,
  fontWeight: 400,
  textAlign: 'center',
  padding: '.5rem 2rem',
  borderRadius: '1rem',
  cursor: 'pointer'
}

export default {
  container: {
    '& button': {
      fontSize: '1.5rem'
    },
    '& p': {
      marginBottom: '1rem'
    }
  },
  errroMsg: {
    paddingTop: '2rem',
    color: COLORS.danger,
    textAlign: 'center'
  },
  infoMsg: {
    marginTop: '1rem'
  },
  cancelButton: {
    marginLeft: '.5rem',
    marginBottom: '2rem',
    background: COLORS.quaternary,
    '&:hover': {
      background: COLORS.quaternaryHover
    }
  },
  buttonContainer: {
    float: 'right'
  },
  buttons: { overflow: 'auto' },
  form: { marginBottom: 0 },
  fileInput: {
    width: '100%',
    padding: '1rem',
    border: '1px solid #ccc',
    boxShadow: 'inset 0 1px 1px rgba(0,0,0,0.075)'
  },
  '@keyframes spin': {
    '100%': {
      transform: 'rotate(360deg)'
    }
  },
  loadingIcon: {
    color: 'white',
    animation: 'spin 4s linear infinite'
  },
  tip: {
    fontSize: '1.4rem',
    marginBottom: '1rem'
  },
  submitFormButton: {
    '&:disabled, &[disabled]': {
      cursor: 'not-allowed',
      background: COLORS.secondary
    }
  },
  column,
  mobileForm: {
    ...column,
    width: '100%',
    marginBottom: '1rem'
  },
  mobileFileInput: {
    width: 0.1,
    height: 0.1,
    opacity: 0,
    overflow: 'hidden',
    position: 'absolute',
    zIndex: -1
  },
  fileInputLabel: {
    ...button,
    '&:hover': {
      background: '#68B1F0'
    }
  },
  mobileLoadingIcon: {
    fontSize: '1.8rem'
  },
  checkboxWrapper: {
    margin: '1rem 0 0 1rem'
  },
  checkboxLabel: {
    display: 'inline',
    fontWeight: 400,
    margin: '0 0 0 .5rem'
  },
  infoTooltip: {
    marginLeft: '1rem',
    color: `${COLORS.primary}`
  }
}



// WEBPACK FOOTER //
// ./src/components/FloorPlanUploader/style.js